import { render, staticRenderFns } from "./AlbumSongs.vue?vue&type=template&id=c589b534&"
import script from "./AlbumSongs.vue?vue&type=script&lang=js&"
export * from "./AlbumSongs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports